// Notifications Service - Wired to real backend
import api from './api';

export const getNotifications = async (unreadOnly = false) => {
  const params = unreadOnly ? '?unread_only=true' : '';
  const response = await api.get(`/notifications${params}`);
  // Return just the data portion, not the axios response wrapper
  return response.data || response;
};

export const markAsRead = async (notificationId) => {
  const response = await api.post(`/notifications/${notificationId}/read`);
  return response.data || response;
};

export const markAllAsRead = async () => {
  const response = await api.post('/notifications/mark-all-read');
  return response.data || response;
};

export const deleteNotification = async (notificationId) => {
  const response = await api.delete(`/notifications/${notificationId}`);
  return response.data || response;
};

// Admin notification methods
export const getInbox = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const res = await api.get(`/admin/notifications/inbox${queryParams ? '?' + queryParams : ''}`);
    const data = res.data || res;
    return { success: true, data: Array.isArray(data.items) ? data.items : Array.isArray(data) ? data : [] };
  } catch (e) {
    if (e.response?.status === 404) {
      return { success: false, notAvailable: true, data: [] };
    }
    return { success: false, data: [], error: e.message };
  }
};

export const getBots = async () => {
  try {
    const res = await api.get('/admin/notifications/bots');
    const data = res.data || res;
    return { success: true, data: Array.isArray(data.bots) ? data.bots : Array.isArray(data) ? data : [] };
  } catch (e) {
    if (e.response?.status === 404) {
      return { success: false, notAvailable: true, data: [] };
    }
    return { success: false, data: [], error: e.message };
  }
};

export const getRoutingRules = async () => {
  try {
    const res = await api.get('/admin/notifications/routing-rules');
    const data = res.data || res;
    return { success: true, data: Array.isArray(data.rules) ? data.rules : Array.isArray(data) ? data : [] };
  } catch (e) {
    if (e.response?.status === 404) {
      return { success: false, notAvailable: true, data: [] };
    }
    return { success: false, data: [], error: e.message };
  }
};

export const getCategories = async () => {
  try {
    const res = await api.get('/admin/notifications/categories');
    const data = res.data || res;
    return { success: true, data: Array.isArray(data.categories) ? data.categories : Array.isArray(data) ? data : [] };
  } catch (e) {
    if (e.response?.status === 404) {
      return { success: false, notAvailable: true, data: [] };
    }
    return { success: false, data: [], error: e.message };
  }
};

export const assignBotToCategory = async (botId, category) => {
  try {
    const res = await api.post('/admin/notifications/assign-bot', { bot_id: botId, category });
    return { success: true, data: res };
  } catch (e) {
    if (e.response?.status === 404) {
      return { success: false, notAvailable: true };
    }
    return { success: false, error: e.message };
  }
};

export const testSend = async (payload) => {
  try {
    const res = await api.post('/admin/notifications/test-send', payload);
    return { success: true, data: res };
  } catch (e) {
    if (e.response?.status === 404) {
      return { success: false, notAvailable: true };
    }
    return { success: false, error: e.message };
  }
};

export const updateRoutingRule = async (ruleId, updates) => {
  try {
    const res = await api.put(`/admin/notifications/routing-rules/${ruleId}`, updates);
    return { success: true, data: res };
  } catch (e) {
    if (e.response?.status === 404) {
      return { success: false, notAvailable: true };
    }
    return { success: false, error: e.message };
  }
};

export default {
  getNotifications,
  markAsRead,
  markAllAsRead,
  deleteNotification,
  getInbox,
  getBots,
  getRoutingRules,
  getCategories,
  assignBotToCategory,
  testSend,
  updateRoutingRule
};
